export default function UserCell({ user }) {
    return (
        <>
            <p className="fw-semibold mb-1">{user.name}</p>
            <p className="text-muted mb-0">{user.email}</p>
        </>
    )
}
